import React from 'react';
import reactDOM from 'react-dom';
import { bemClasses } from 'general/js/modal';
import { ReactModal } from 'components/modal';
import { RouteToHolePlayer } from '../../route-to-hole-player';
import { 
    getLiveBlogRouteToHoleConfig,
    getR2hVideoSrc,
    getR2hThumbnailSrc
} from '../../route-to-hole-player/js/route-to-hole-helpers';
import { hasValue } from '../../../general/js/general-helpers';

class RouteToHoleModal {
    constructor() {
        this.root = document.createElement('div');
        this.root.id = 'route-to-hole-modal';
        document.body.appendChild(this.root);

        this.modal = null;
        this.state = {
            model: null,
            config: null
        };
    }

    destroy() {
        reactDOM.unmountComponentAtNode(this.root);
    }

    show = (model, config = {}) => {
        if (!hasValue(model) || !hasValue(config)) return;

        this.state.model = model;
        this.state.config = config;
        this.render();
    }

    hide = () => {
        this.state.model = null;
        this.state.config = null;
        this.render();
    }

    render() {
        const { model, config } = this.state;
        const videoSource = hasValue(model) ? getR2hVideoSrc(model.videoId, getLiveBlogRouteToHoleConfig(config)) : null ;
        const thumbnailSrc = hasValue(model) ? getR2hThumbnailSrc(model.videoId, getLiveBlogRouteToHoleConfig(config)) : null ;
        const modalOptions = {
            bemList: [bemClasses.WIDE, bemClasses.CLOSE_OUTSIDE]
        };
        
        reactDOM.render(
            <ReactModal
                options={modalOptions}
                isOpen={hasValue(videoSource)}
                onCloseCb={this.hide}
            >
                {   hasValue(videoSource) && 
                    <RouteToHolePlayer videoSource={videoSource} thumbnailSource={thumbnailSrc}/>
                }
            </ReactModal>,
            this.root
        );
    }
}

export default new RouteToHoleModal();
